<div class="container p-4">
  <div class="flex flex-col justify-center">
    <div mat-dialog-title class="flex p-0">
      <h1
        class="align-center flex m-0 p-0 d-block d-flex align-items-center"
        mat-dialog-title
      >
        <mat-icon class="text-danger" svgIcon="mat:warning"></mat-icon>
        <span class="mx-2 popup-title">{{ 'Confirm' | translate }}</span>
      </h1>
    </div>
    <div mat-dialog-content class="mat-dialog-content p-0 d-flex flex-column">
      <h5>
        {{
        data?.message
          ? data?.message
          : ('Are you sure you want to delete?' | translate)
        }}
      </h5>
      <div class="d-flex flex-row mt-3 flex-wrap">
        <ng-container *ngFor="let item of rows; let last = last">
          <div
            class="badge d-flex align-items-center justify-content-center ltr:ml-2 rtl:mr-2 my-1"
            *ngIf="item?.name"
          >
            {{ item?.name || item?.title }}
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div mat-dialog-actions class="d-flex justify-end mt-2 p-0">
    <button mat-raised-button class="mx-2 warn-bg" mat-dialog-close>
      {{ 'Cancel' | translate }}
    </button>
    <button
      (click)="yes()"
      color="primary"
      mat-raised-button
      class="primary-bg"
      cdkFocusInitial
    >
      {{ 'Confirm' | translate }}
    </button>
  </div>
</div>
